import * as R from 'ramda';
import React from 'react';

import HelpBubble from 'js/components/help_bubble';

const Checkbox = props => (
    <label className={props.className}>
        <input
            type="checkbox"
            name={props.name}
            checked={R.isNil(props.checked) ? false : props.checked}
            onChange={props.onChange}
        />
        &nbsp;
        {props.label}
        &nbsp;
        {props.help && <HelpBubble text={props.help} multiline place="right" inline />}
    </label>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/check_box.js